/**
 * Tenant wise add on features
 */
export enum AddOnFeature {
    Firmware,
    Dashboard
}
